export default __webpack_public_path__ + "static/media/dns-spiral@3x.88b419b8.png";